import React from 'react';
import sourcingMap from '@/assets/origins/sourcing_map.jpg';
import { originsContent } from '@/content/origins';
import OriginLocation from './OriginLocation';
import { Reveal, Section } from '@/components/ui';

const Origins: React.FC = () => {
    return (
        <Section id="origins" className="origins" title={originsContent.sectionTitle}>
            <div className="origin-grid">
                {originsContent.cards.map((card, index) => (
                    <OriginLocation key={card.title} {...card} delay={index * 100} />
                ))}
            </div>
            <div className="map-frame-container">
                <Reveal as="div" className="origin-card map-card card">
                    <img
                        src={sourcingMap}
                        alt={originsContent.mapAlt}
                        className="supply-map"
                        loading="lazy"
                        decoding="async"
                    />
                </Reveal>
            </div>
        </Section>
    );
};

export default Origins;
